import { FETCH_PUBSITES } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_PUBSITES:
      return { ...state, data: action.payload.data };
    default:
      return state;
  }
};
